import React from 'react';
import { useCommon } from 'src/domains/common/Common';
import { LanguagesState } from 'src/domains/layouts/state/languagesState/LanguagesState';
import { CustomColumnsLayout } from 'src/domains/sportsbook/webview/components/eventMarkets/marketGroup/outrightMarket/CustomColumnsLayout';
import { getEachWayTerms } from 'src/domains/sportsbook/webview/components/marketHeader/getEachWayTerms';
import { MarketHeader } from 'src/domains/sportsbook/webview/components/marketHeader/MarketHeader';
import { observer } from 'src/utils/mobx-react';
import { EventId, MarketId } from 'src_common/common/websocket2/id/WebsocketId';
import { MarketModel } from 'src_common/common/websocket2/models/MarketModel';
import { SelectionModel } from 'src_common/common/websocket2/models/SelectionModel/SelectionModel';

const getMarket = (markets: Array<MarketId>): MarketModel | null => {
    const marketId = markets[0];

    if (marketId !== undefined) {
        return marketId.getModel();
    }
    return null;
};

interface PropsType {
    eventId: EventId;
    markets: Array<MarketId>;
    selections: Record<string, SelectionModel[]>;
    isOpen: boolean;
    displayTemplate: string;
    onClick(): void;
}

export const OutrightMarketUnified = observer('OutrightMarketUnified', (props: PropsType) => {
    const { eventId, markets, selections, isOpen, onClick, displayTemplate } = props;

    const common = useCommon();
    const languagesState = LanguagesState.get(common);

    const marketModel = getMarket(markets);
    const event = eventId.getEventModel();

    if (event === null || marketModel === null) {
        return null;
    }

    return (
        <div className='market-group--outright'>
            <MarketHeader
                name={languagesState.getMarketTranslationName(
                    marketModel.name,
                    marketModel.eventModel?.participants ?? null
                )}
                isOpen={isOpen}
                onClick={onClick}
                marketId={marketModel.id2}
                event={event}
                eachWayTerms={getEachWayTerms(marketModel)}
            />

            {isOpen ? (
                <CustomColumnsLayout
                    displayTemplate={displayTemplate}
                    selections={selections}
                />
            ) : null}
        </div>
    );
});
